import React from "react";
import { Box, CircularProgress } from "@mui/material";
import StaffList from "./stafflist";
import PlantList from "./plantlist";

const LayoutComponent = ({
  loader,
  staffData,
  plantData,
  project_name,
  currentProject,
  selectItem,
  setSelectItem,
  selectType,
  isSelect,
  active,
}) => {
  if (loader) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 400,
        }}
      >
        <CircularProgress size={60} sx={{ color: "#fa4b4b" }} />
      </Box>
    );
  }

  const renderActiveComponent = () => {
    switch (active?.toLowerCase()) {
      case "staff":
      case "stafflist":
        return (
          <StaffList
            projectData={currentProject}
            selectItem={selectItem}
            setSelectItem={setSelectItem}
            isSelect={isSelect}
          />
        );

      case "plant":
      case "plantlist":
        return (
          <PlantList
            projectData={currentProject}
            selectItem={selectItem}
            setSelectItem={setSelectItem}
            isSelect={isSelect}
          />
        );

      default:
        return (
          <Box sx={{ display: "flex", gap: 2 }}>
            <Box sx={{ flex: 1 }}>
              <StaffList
                projectData={currentProject}
                selectItem={selectItem}
                setSelectItem={setSelectItem}
                isSelect={isSelect}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <PlantList
                projectData={currentProject}
                selectItem={selectItem}
                setSelectItem={setSelectItem}
                isSelect={isSelect}
              />
            </Box>
          </Box>
        );
    }
  };

  return (
    <Box>
      {renderActiveComponent()}
    </Box>
  );
};

export default LayoutComponent;